// In useCountdownTimer.ts
import { useState, useEffect, useCallback } from 'react'

function convertTimeValue(value: number) {
  return value > 9 ? value : `0${value}`
}

export default function useCountdownTimer(initialExpirationTime: number, timerConstant: number, withHours?: boolean) {
  const [timer, setTimer] = useState('')
  const [isLinkExpired, setIsLinkExpired] = useState(false)
  const [expirationTime, setExpirationTime] = useState(initialExpirationTime)
  const [isTimerLoading, setIsTimerLoading] = useState(true)

  useEffect(() => {
    if (initialExpirationTime !== expirationTime && initialExpirationTime > 0) {
      setExpirationTime(initialExpirationTime)
      setIsTimerLoading(true)
      setIsLinkExpired(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialExpirationTime])

  const resetTimer = useCallback(() => {
    const newExpirationTime = new Date().getTime() + timerConstant
    setExpirationTime(newExpirationTime)
    setIsLinkExpired(false)
    setIsTimerLoading(true)
  }, [timerConstant])

  useEffect(() => {
    if (!expirationTime || expirationTime === 0) {
      setIsTimerLoading(false)
      setTimer('')

      return
    }

    const expirationDate = new Date(expirationTime)
    const timerInterval = setInterval(() => {
      const now = new Date()
      const timeLeft = expirationDate.getTime() - now.getTime()

      if (timeLeft <= 0) {
        setIsLinkExpired(true)
        setTimer('')
        setIsTimerLoading(false)
        clearInterval(timerInterval)
      } else {
        const totalSeconds = Math.floor(timeLeft / 1000)
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = withHours ? Math.floor((totalSeconds % 3600) / 60) : Math.floor(timeLeft / 1000 / 60)
        const seconds = totalSeconds % 60

        if (withHours) {
          setTimer(`${convertTimeValue(hours)}:${convertTimeValue(minutes)}:${convertTimeValue(seconds)}`)
        } else {
          setTimer(`${convertTimeValue(minutes)}:${convertTimeValue(seconds)}`)
        }
        setIsLinkExpired(false)
        setIsTimerLoading(false)
      }
    }, 1000)

    return () => clearInterval(timerInterval)
  }, [expirationTime, withHours])

  return { timer, isLinkExpired, resetTimer, isTimerLoading }
}
